import { navLinks } from '@/mocks/homeData';

export default function Footer() {
  const quickTopics = ['文娱内容', '直播电商', '品牌营销', '体育赛场', '科技发布', '网络综艺'];

  return (
    <footer className="bg-primary-950 text-primary-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">爆料看点</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200 max-w-xs">
              把系列爆料追踪、同类事件对比与相似案例合集放在同一页，横向比较，一条线索吃透到底。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">站内导航</h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-primary-200 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">主题分类</h4>
            <ul className="space-y-2.5">
              {quickTopics.map((topic) => (
                <li key={topic}>
                  <a
                    href="#topics"
                    className="text-sm text-primary-200 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {topic}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系与投递</h4>
            <p className="text-sm text-primary-200 mb-3">有值得追踪的线索，欢迎随时投递。</p>
            <a
              href="mailto:contact@baokandian.example.com"
              className="inline-flex items-center gap-2 text-sm text-background-50 hover:text-accent-300 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              contact@baokandian.example.com
            </a>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 text-primary-100">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 text-primary-100">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 text-primary-100">
                <i className="ri-mail-send-line"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-900 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-300 text-center sm:text-left">
            本站内容基于公开信息整理，仅作事件脉络梳理与横向对照参考，不构成任何结论性判断。
          </p>
          <p className="text-xs text-primary-300 whitespace-nowrap">© 2026 爆料看点 · 保留所有权利</p>
        </div>
      </div>
    </footer>
  );
}